<template>
    <div>
        <div :class="styles.FORM.FORM_GROUP">
            <label>Text for Text-Block</label>
            <textarea type="text" :class="styles.FORM.FORM_CONTROL" v-model="control.text" rows="6"></textarea>
        </div>

        <div :class="styles.FORM.FORM_GROUP" v-for="lang in enabledTranslationLanguages" :key="'text-' + lang.code">
            <label>Text for Text-Block ({{ lang.name }})</label>
            <textarea type="text" :class="styles.FORM.FORM_CONTROL" v-model="control['text' + lang.suffix]" rows="6" :placeholder="lang.name + ' text'"></textarea>
            <small v-if="control['text' + lang.suffix + 'Manual']" class="form-text text-info">
                <i class="fa fa-pencil"></i> Manually edited
            </small>
        </div>
    </div>
</template>

<script>
    import {CONTROL_SPECIAL_CONFIG_MIXIN} from "../../mixins/control-special-config-mixin";

    export default {
        name: "TextBlockConfigView",
        mixins: [CONTROL_SPECIAL_CONFIG_MIXIN]
    }
</script>